import { Box } from "@mui/system";
import { Chart, Tooltip, Axis, Polygon, Legend } from 'bizcharts';
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import DownloadButton from "../Common/DownloadButton";

const HeatMapChart = (props) => {
    const [data, setData] = useState([]);

    const csv = props.csv;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                setData(results.data);
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, []);
    const xAxis = [];
    let yAxis = [];
    data.forEach(d => {
        if (yAxis.indexOf(d[props.yAxisName]) < 0) {
            yAxis.push(d[props.yAxisName]);
        }
        if (xAxis.indexOf(d[props.xAxisName]) < 0) {
            xAxis.push(d[props.xAxisName]);
        }
    });
    yAxis = yAxis.sort((a, b) => { return (a < b) ? 1 : -1 });
    const transform = [];
    data.forEach(d => {
        const xIndex = xAxis.indexOf(d[props.xAxisName]);
        const yIndex = yAxis.indexOf(d[props.yAxisName]);
        const value = d[props.valueField];
        const commodity = d['Food commodity'];
        transform.push([xIndex, yIndex, value, commodity]);
    });

    /*
        const data = [
            [0, 0, 10],
            [0, 1, 19],
            [0, 2, 8],
            [0, 3, 24],
            [0, 4, 67],
            [1, 0, 92],
            [1, 1, 58],
            [1, 2, 78],
            [1, 3, 117],
            [1, 4, 48],
            [2, 0, 35],
            [2, 1, 15],
            [2, 2, 123],
            [2, 3, 64],
            [2, 4, 52],
            [3, 0, 72],
            [3, 1, 132],
            [3, 2, 114],
            [3, 3, 19],
            [3, 4, 16],
            [4, 0, 38],
            [4, 1, 5],
            [4, 2, 8],
            [4, 3, 117],
            [4, 4, 115],
            [5, 0, 88],
            [5, 1, 32],
            [5, 2, 12],
            [5, 3, 6],
            [5, 4, 120],
            [6, 0, 13],
            [6, 1, 44],
            [6, 2, 88],
            [6, 3, 98],
            [6, 4, 96],
            [7, 0, 31],
            [7, 1, 1],
            [7, 2, 82],
            [7, 3, 32],
            [7, 4, 30],
            [8, 0, 85],
            [8, 1, 97],
            [8, 2, 123],
            [8, 3, 64],
            [8, 4, 84],
            [9, 0, 47],
            [9, 1, 114],
            [9, 2, 31],
            [9, 3, 48],
            [9, 4, 91],
        ];
    */
    const source = transform.map((arr) => {
        return {
            commodities: arr[0],
            quantifications: arr[1],
            percent: arr[2],
            commodity: arr[3],
        };
    });

    const scale = {
        commodities: {
            type: 'cat',
            values: xAxis,
        },
        quantifications: {
            type: 'cat',
            values: yAxis,
        },
        percent: {
            nice: true
        }
    };

    const [canvas, setCanvas] = useState(undefined);

    return (
        <Box>
            <Box display='flex' justifyContent='space-between'>
                <p style={{ fontFamily: 'Roboto Condensed, sans-serif', width: '100%', marginBottom: '.5rem' }}>{props.title}</p>
                <DownloadButton canvas={canvas} fileName={props.title} csv={data} isRaw />
            </Box>
            <Chart
                scale={scale}
                height={350}
                data={source}
                autoFit
                onGetG2Instance={chartInstance => {
                    setCanvas(chartInstance.canvas);
                }}
            >
                <Axis
                    name={'commodities'}
                    tickLine={null}
                    label={{
                        style: {
                            fontFamily: 'Roboto Condensed, sans-serif',
                            fontWeight: 'bolder'
                        }
                    }}
                    grid={{
                        alignTick: false,
                        line: {
                            style: {
                                lineWidth: 1,
                                lineDash: null,
                                stroke: '#f0f0f0',
                            },
                        },
                    }}
                />
                <Axis
                    name={'quantifications'}
                    title={null}
                    label={{
                        style: {
                            fontFamily: 'Roboto Condensed, sans-serif',
                        }
                    }}
                    grid={{
                        alignTick: false,
                        line: {
                            style: {
                                lineWidth: 1,
                                lineDash: null,
                                stroke: '#f0f0f0',
                            },
                        },
                    }}
                />
                <Tooltip customContent={(title, content) => {
                    console.log(title, content[0]);
                    if (content[0]) {
                        return '<p style=" padding-top: .5rem; padding-left: .5rem; margin: 0"><b>' + content[0].data.commodity + '</b></p>' + '<li style="list-style: none; padding: .5rem 0" data-index={index}>'
                            + '<span style="background-color:' + content[0].color + ';width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>'
                            + title + ' Quantified residues per sample: ' + content[0].data.percent + '%'
                            + '</li>';
                    }
                    return '';
                }} />
                <Legend />


                <Polygon
                    position={'commodities*quantifications'}
                    color={['percent', '#C8DAE6-#317EB5-#246898']}
                    label={['percent', (percent) => {
                        return {
                            offset: -2,
                            style: {
                                fill: (percent > 20) ? '#fff' : '#246898',
                                shadowBlur: 2,
                                shadowColor: 'rgba(0, 0, 0, .45)',
                            },
                        };
                    }]}
                    style={{
                        lineWidth: 1,
                        stroke: '#fff',
                    }}
                >
                </Polygon>
            </Chart>
        </Box>
    );
}

export default HeatMapChart;